import { FaBook } from "react-icons/fa6";

interface BookCitationsProps {
  citation: string[] | any;
  onCitationClick?: (citation: string) => void;
}
function BookCitations({ citation, onCitationClick }: BookCitationsProps) {
  const curatedBookName = citation.book_name;
  function onCitationClicked(citations: any): void {
    if (onCitationClick) {
      onCitationClick(citations);
    }
  }
  return (
    <div>
      <button
        onClick={e => {
          e.preventDefault();
          onCitationClicked(citation);
        }}
        className="cursor-pointer text-left block whitespace-normal link_text_color hover:underline"
      >
        {curatedBookName} - {citation.title} &nbsp;
        <FaBook className="inline" title="Book" />
      </button>
    </div>
  );
}

export default BookCitations;
